/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eslint-comments/no-duplicate-disable */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, resetReduxStore } from '../../store'
import {
  selectMenuItemById,
  setSelectedItemIds,
  setSelectedItems,
} from '../SideNavigation/SideNavigationSlice'

//Icon imports:
import UserIcon from '../../assets/icons/UserIcon'
import chevron from '../../assets/chevron.svg'
import WeatherSensorDetailsIcon from '../../assets/icons/WeatherSensorDetailsIcon'
import LogoutIcon from '../../assets/icons/LogoutIcon'
import ThresholdsIcon from '../../assets/icons/ThresholdsIcon'
import FaqIcon from '../../assets/icons/FaqIcon'
import SavedViewIcon from '../../assets/icons/SavedViewIcon'
import DeleteIcon from '../../assets/icons/DeleteIcon'
import FeatureGate from '../../Components/FeatureGate/FeatureGate'
import { MENU_ID } from '../../environment/featureFlags'

import {
  createSavedView,
  deleteSavedView,
} from '../../Components/SavedViews/savedViews'
import { setSavedProfile } from '../../Components/SavedViews/savedViewsSlice'
import RestoreSelection from '../../Components/SavedViews/RestoreSelection'
import useErrorStatus from '../../hooks/UseErrorStatus'
import {
  baseMapItems,
  exclusiveItems,
  toggledItems,
} from '../SideNavigation/SideNavigation'
import { ErrorTimeouts } from '../../constants/ErrorTimeouts'
import { useAuth0 } from '@auth0/auth0-react'

export default function ProfileMenu() {
  const [show, setShow] = useState(false)
  const selectedItems = useSelector(
    (state: RootState) => state.sideNav.selectedItems
  )
  const selectedItemIds = useSelector(
    (state: RootState) => state.sideNav.selectedItems
  )
  const firstname = useSelector(
    (state: RootState) => state.user.firstname || state.user.name
  )
  const lastname = useSelector((state: RootState) => state.user.lastname)
  const signInRef = useRef(null)
  const signUpRef = useRef(null)
  const itemSelected = () => {
    setShow(false)
  }
  const { logout } = useAuth0()

  const isDarkMode = useSelector((state: RootState) => state.mapState.darkMode);

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    })

  const handleMenuToggle = () => {
    setShow(!show)
  }

  return (
    <>
      <div
        className={`flex flex-row justify-start text-center self-center px-4 w-64 cursor-pointer text-white`}
        onClick={handleMenuToggle}
      >
        <div>
          <UserIcon darkMode={true} />
        </div>
        <span className="capitalize">{firstname}</span>
        <img
          className="invert float-right mt-2 mr-4 mb-0 ml-4"
          src={chevron}
          alt=""
          style={{ filter: 'brightness(0) invert(1)' }}
        />
      </div>
      <div
        className={`absolute block transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in overflow-hidden ${
          isDarkMode ? 'bg-black text-white' : 'bg-white text-black'
        }
            ${
              show
                ? 'max-h-1/4 opacity-100 scale-100'
                : 'max-h-0 opacity-0 scale-95'
            }
          } top-16 right-1 w-72 z-[99999] shadow-lg rounded-b-lg p-4 space-y-4`}
      >
        <div className="capitalize font-semibold space-y-2">
          {firstname} {lastname}
        </div>

        <hr className="border-gray-700" />

        <div className="space-y-2">
          <Link to="/userprofile" onClick={itemSelected}>
            <div
              className={`flex items-center gap-2 h-8 cursor-pointer ${
                isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
              }`}
            >
              <UserIcon darkMode={isDarkMode} />
              <p>Your Profile</p>
            </div>
          </Link>
          <Link to="/sensordetails" onClick={itemSelected}>
            <div
              className={`flex items-center gap-2 h-8 cursor-pointer ${
                isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
              }`}
            >
              <WeatherSensorDetailsIcon darkMode={isDarkMode} />
              <p>Weather Sensor Details</p>
            </div>
          </Link>
          <Link to="/customthresholds" onClick={itemSelected}>
            <div
              className={`flex items-center gap-2 h-8 cursor-pointer ${
                isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
              }`}
            >
              <ThresholdsIcon darkMode={isDarkMode} />
              <p>Units & Thresholds</p>
            </div>
          </Link>
          {/*
            Monitors and Alerts is gated on both axes - the build-time flag and
            the user's region. Alerting is listed in every region's product set,
            so `requireRegion` is not restricting today; it is passed so this
            entry answers the same question the side nav does, and so removing
            alerting from a region later takes effect here too.
          */}
          <Link to="https://truweathersolutions.gitbook.io/info/documentation" target="_blank" onClick={itemSelected}>
            <div
              className={`flex items-center gap-2 h-8 cursor-pointer ${
                isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
              }`}
            >
              <FaqIcon darkMode={isDarkMode} />
              <p>Help</p>
            </div>
          </Link>
        </div>

        <hr className="border-gray-700" />

        <div className="space-y-2">
          <Link to="." onClick={logoutWithRedirect}>
            <div
              className={`flex items-center gap-2 h-8 cursor-pointer ${
                isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
              }`}
            >
              <LogoutIcon darkMode={isDarkMode} />
              <p>Logout</p>
            </div>
          </Link>
        </div>
      </div>
    </>
  )
}
